import { useContext, useEffect, useRef } from "react";
import { Context } from "../../context/Context";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import "./EquipmentButtonIconModal.css";
import { UpdateEquipmentButton, UpdateScenario } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";

const ScenarioIconModal = () => {
  const {
    setScenarioIconModal,
    editScenarioIcon,
    setUpdate,
    update,
    setIsLoading,
    scenarios,
    setScenarios,
  } = useContext(Context);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setScenarioIconModal(modalName);
  }, []);

  const handleChangeButtonIcon = (iconId) => {
    setIsLoading(true);
    UpdateScenario({
        scenario_id: editScenarioIcon.id,
        name: editScenarioIcon.name,
        type: editScenarioIcon.type ?? 0,
        repeat: editScenarioIcon.repeat,
        icon: iconId,
    })
      .then((res) => {
        if (res.status == 200) {
          SuccessToast("آیکون با موفقیت تغییر یافت");
          const index = scenarios.findIndex(
            (item) => item.id == editScenarioIcon.id,
          );

          if (index !== -1) {
            const updateScenarios = [...scenarios];
            updateScenarios[index] = {
              ...updateScenarios[index],
              icon: iconId,
            };

            setScenarios(updateScenarios);
          }
          closeButton.current.click();
          setUpdate(!update);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderIcons = () => {
    return EquipmentButtonIcons.map((icon, index) => {
      if (icon.id <= 32)
        return (
          <div key={index} onClick={() => handleChangeButtonIcon(icon.id)}>
            <img src={icon.path} alt={`Icon ${index}`} />
          </div>
        );
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentIconModal"
      tabIndex="-1"
      aria-labelledby="equipmentIconModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              انتخاب آیکون
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="icon-images d-flex justify-content-around flex-wrap">
              {renderIcons()}
            </div>
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-success-app"
              data-bs-dismiss="modal"
              ref={closeButton}
            >
              انصراف
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ScenarioIconModal;
